import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsPhotoNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M12.5 5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm-2 4.5a2 2 0 114 0 2 2 0 01-4 0z" />
        <path d="M1 4.25A3.25 3.25 0 014.25 1h23.5A3.25 3.25 0 0131 4.25v23.5A3.25 3.25 0 0127.75 31H4.25A3.25 3.25 0 011 27.75zm3.25-.75a.75.75 0 00-.75.75v15.732l3.173-3.173a2.583 2.583 0 013.654 0L13 19.482l8.673-8.673a2.583 2.583 0 013.654 0l3.173 3.173V4.25a.75.75 0 00-.75-.75zM3.5 27.75c0 .414.336.75.75.75h23.5a.75.75 0 00.75-.75V17.518l-4.941-4.941a.083.083 0 00-.118 0L13 23.017l-4.441-4.44a.083.083 0 00-.118 0L3.5 23.517z" />
      </g>
    </svg>
  )
);
SvgActionsPhotoNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsPhotoNormalMedium;
